import { render, staticRenderFns } from "./PriceConfigItemsHeader.vue?vue&type=template&id=31dde363&"
import script from "./PriceConfigItemsHeader.vue?vue&type=script&lang=ts&"
export * from "./PriceConfigItemsHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports